class NovaPagination extends HTMLElement {
  constructor() {
    super();

    const paginationUrl = this.getAttribute("data-pagination-url");
    if (!paginationUrl) {
      throw new Error("Component is missing attribute data-pagination-url");
    }

    const input = this.querySelector("input[data-pagination-role=input]");

    if (!input) {
      throw new Error("Component is missing element input[data-pagination-role=input]");
    }

    const overlay = document.createElement("div");
    overlay.className = "overlay--pagination";

    this.appendChild(overlay);

    const max = parseInt(input.getAttribute("max"));

    input.oninput = window.Nova.utils.debounce(() => {
      const currentValue = Math.max(Math.min(parseInt(input.value ? input.value : 0), max), 1);

      if (currentValue) {
        const url = new URL(location.origin + paginationUrl);

        url.searchParams.set("page", currentValue);

        this.setAttribute("data-pagination-state", "loading");
        location.href = url.toString();
      }
    }, 400);
  }
}

if (!customElements.get("nova-pagination")) {
  customElements.define("nova-pagination", NovaPagination);
}
